import React, { Component } from 'react';
import { connect } from 'react-redux';
import Radium from 'radium';
import { func } from 'prop-types';
import { formatDateFullFormat } from '@widergy/web-utils/lib/date';
import { UTLabel } from '@widergy/energy-ui';

import { formResponsePropTypes, actionCreators as userFormActions } from 'redux/userFormHandlers';
import { message } from 'utils/stringUtils';

import Thumbnail from './components/Thumbnail';
import ActionClaims from './components/ActionClaims';
import styles from './styles';

const fieldDetailFormatter = (field = {}, index, lastElementIndex) => (
  <div style={index === lastElementIndex ? styles.lastField : styles.field} key={index}>
    <UTLabel bold>{field.name}</UTLabel>
    {field.format && field.format.image ? (
      <Thumbnail
        imageModal={JSON.parse(field.value).fileUrl}
        imageThumbnail={JSON.parse(field.value).thumbnailUrl}
      />
    ) : (
      <UTLabel darkGray>{field.value}</UTLabel>
    )}
  </div>
);

class FieldDetail extends Component {
  componentWillMount = () =>
    this.props.dispatch(
      userFormActions.getFormResponseDetails(
        this.props.rowData.id,
        this.props.rowData.account_id,
        this.props.rowData.form_type
      )
    );

  render() {
    const fieldsToDisplay = () => {
      const fields = [];
      if (this.props.rowData.completion_at)
        fields.push({
          name: message('FieldDetails:completionAt'),
          value: formatDateFullFormat(this.props.rowData.completion_at)
        });
      else if (this.props.rowData.expected_completion_at)
        fields.push({
          name: message('FieldDetails:expectedCompletionAt'),
          value: formatDateFullFormat(this.props.rowData.expected_completion_at)
        });

      fields.push(this.props.rowData.field_details);
      return fields;
    };

    return (
      <div style={[this.props.style, styles.activeRowContent]}>
        <div style={styles.fieldContainer}>
          {fieldsToDisplay().map((field, index) =>
            fieldDetailFormatter(field, index, fieldsToDisplay().length - 1)
          )}
        </div>
        <div style={styles.buttonContainer}>
          <ActionClaims
            rowData={this.props.rowData}
            handleOpenActionModal={this.props.handleOpenActionModal}
          />
        </div>
      </div>
    );
  }
}

FieldDetail.propTypes = {
  rowData: formResponsePropTypes,
  handleOpenActionModal: func
};

export default connect()(Radium(FieldDetail));
